module.exports = __webpack_public_path__ + "static/livermore-55bae542e558371928dad241e9179e94.jpg";